export default "__VITE_ASSET__BBxbsd2i__"